import React, { AriaAttributes } from 'react'
import styled from '@emotion/styled'
import money, { MoneyProps } from 'shared/helpers/money'
import { PriceWrapperProps } from './PriceWrapper'
import { useRouter } from 'next/router'
import { margin, MarginProps } from 'styled-system'

export interface PriceProps
  extends PriceWrapperProps,
    MoneyProps,
    MarginProps,
    Pick<AriaAttributes, 'aria-label'> {}

/**
 * Converts pence to a currency and displays it with the unit. Uses the logic from `money()`
 * whilst providing the locale internally. Provides a div wrapper for styling.
 */
const Price = ({
  pence,
  currency,
  wholeNumber,
  strike = false,
  ...other
}: PriceProps) => {
  const { locale } = useRouter() || {}
  return (
    <StyledPrice strike={strike} {...other}>
      {money({
        pence,
        currency,
        wholeNumber,
        locale
      })}
    </StyledPrice>
  )
}

export default Price

export const StyledPrice = styled.div<PriceWrapperProps>(
  ({ theme, fontStyle, color, strike }) => ({
    color: color ? theme.colors.text[color] : undefined,
    textDecoration: strike ? 'line-through' : undefined,
    ...(fontStyle && { ...theme.fontStyle[fontStyle] })
  }),
  margin
)
